/**
 * Redact booking credentials before anything leaves the browser for telemetry.
 *
 * ROOT CAUSE this exists (Sep 2026): Sentry issue JAVASCRIPT-REACT-D recorded
 * its culprit as `/client-view/<a real 43-char token>`. That token IS the
 * credential — anyone who can read the error log can open that client's
 * booking portal, approve a contract or start a card payment. Raising capture
 * to every occurrence multiplies the exposure, so the path, the transaction
 * name, the URL tag and every breadcrumb are scrubbed on the way out.
 *
 * Only the token SEGMENT is replaced. Static asset paths (/static/js/*.chunk.js)
 * are left in full — they are the evidence that settles 404-vs-timeout.
 */

// Path prefixes whose next segment is an access token, not an identifier.
const TOKEN_PREFIXES = /\/(client-view|songs|feedback|brief|live\/all|live|pay|payment|payments\/client|event-command)\/[^/?#]+/g;
// Query parameters that carry a credential or a checkout identifier.
const SENSITIVE_PARAMS = ['token', 'session_id', 'portal_token', 'portalToken', 't'];

export function redactPath(pathname) {
  const raw = String(pathname || '');
  return raw.replace(TOKEN_PREFIXES, (_m, prefix) => `/${prefix}/<token>`);
}

export function redactString(value) {
  if (!value) return value;
  let out = String(value).replace(TOKEN_PREFIXES, (_m, prefix) => `/${prefix}/<token>`);
  SENSITIVE_PARAMS.forEach((p) => {
    out = out.replace(new RegExp(`([?&]${p}=)[^&#\\s]+`, 'gi'), `$1<redacted>`);
  });
  return out;
}

export function currentRedactedPath() {
  if (typeof window === 'undefined') return '';
  return redactPath(window.location.pathname);
}

export default redactString;
